<template>
  <b-container id="form" fluid>
    <form>
      <b-row class="px-3">
        <b-col cols="auto" class="my-2">
          <div class="select-box">
            <div class="date-box">
              <div class="select-box">
                <div
                  class="datepicker-trigger2 input-group"
                  @mouseover="activeCloseDate = true"
                  @mouseleave="activeCloseDate = false"
                >
                  <input
                    id="datepicker-trigger2"
                    class="form-control border-right-0"
                    type="text"
                    autocomplete="off"
                    placeholder="เลือกวันที่"
                    :value="formatDates(filter.dateOne, filter.dateTwo)"
                  />
                  <div class="input-group-prepend bg-white">
                    <span
                      id="basic-addon1"
                      class="input-group-text border-left-0 rounded-right bg-white"
                      ><fa-icon
                        :style="{
                          opacity: activeCloseDate ? 1 : 0,
                        }"
                        :icon="['fas', 'times']"
                        class="icon"
                        @click="clearDate"
                      />
                    </span>
                  </div>

                  <AirbnbStyleDatepicker
                    :trigger-element-id="'datepicker-trigger2'"
                    :mode="'range'"
                    :show-shortcuts-menu-trigger="false"
                    :fullscreen-mobile="true"
                    :date-one="filter.dateOne"
                    :date-two="filter.dateTwo"
                    @date-one-selected="
                      (val) => {
                        filter.dateOne = val;
                      }
                    "
                    @date-two-selected="
                      (val) => {
                        filter.dateTwo = val;
                      }
                    "
                    @apply="filters(filter)"
                  />
                </div>
              </div>
            </div>
          </div>
        </b-col>
        <b-col cols="auto" class="my-2">
          <div class="search-box">
            <div class="select-hospital">
              <b-form-select
                v-model="hospitalSelected"
                :options="hospitalist"
                text-field="name"
                value-field="id"
                @change="filters(filter)"
              />
            </div>
            <div class="search">
              <div class="search-icon" @click="filters(filter)">
                <fa-icon icon="search" />
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
    </form>
  </b-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import moment from "moment-timezone";
import format from "date-fns/format";

export default {
  name: "InputInvoiceFilterComponent",
  props: {
    isHospitalSelected: {
      type: Boolean,
    },
  },
  data() {
    return {
      activeCloseDate: false,
      filter: {
        hospital: null,
        dateOne: "",
        dateTwo: "",
      },
      dateFormat: "D/MM/YYYY",
      hospitalSelected: "",
      hospitalist: [],
    };
  },
  mounted() {
    this.filter.status_id = this.statusId;
    let today = moment.tz("Asia/Bangkok").format("YYYY-MM-DD");
    this.filter.dateOne = today;
    document.getElementById("datepicker-trigger").value = format(
      today,
      this.dateFormat
    );
    this.hospitalist = [
      { name: "เลือกรายชื่อลูกค้า", id: 0 },
      ...this.hospitals,
    ];

    this.hospitalSelected = 0;
  },
  created() {
    let today = moment.tz("Asia/Bangkok").format("YYYY-MM-DD");
    const res = {
      hospital: this.hospitalSelected,
      dateOne: today,
      dateTwo: today,
    };
    this.filters(res);
  },
  computed: {
    ...mapGetters({
      hospitals: "Hospital/getAll",
    }),
  },
  methods: {
    ...mapActions({
      filterOrder: "Account/filterData",
    }),
    filters(obj) {
      let val = {};
      if (obj.dateTwo === "") {
        val = {
          hospital_id:
            this.hospitalSelected != null ? this.hospitalSelected : "",
          start_date: obj.dateOne
            ? moment(obj.dateOne).format("YYYY-MM-DD")
            : "",
          end_date: obj.dateOne ? moment(obj.dateOne).format("YYYY-MM-DD") : "",
        };
      } else {
        val = {
          hospital_id:
            this.hospitalSelected != null ? this.hospitalSelected : "",
          start_date: obj.dateOne
            ? moment(obj.dateOne).format("YYYY-MM-DD")
            : "",
          end_date: obj.dateTwo ? moment(obj.dateTwo).format("YYYY-MM-DD") : "",
        };
      }
      this.filterOrder(val);
    },
    formatDates(dateOne, dateTwo) {
      let formattedDates = "";
      if (dateOne) {
        formattedDates = format(dateOne, this.dateFormat);
      }
      if (dateTwo) {
        formattedDates += " - " + format(dateTwo, this.dateFormat);
      }
      return formattedDates;
    },
    clearDate() {
      this.filter.dateOne = "";
      this.filter.dateTwo = "";
      this.filters(this.filter);
    },
  },
  watch: {
    hospitalSelected(val) {
      if (val > 0) {
        this.$emit("update:isHospitalSelected", true);
      } else {
        this.$emit("update:isHospitalSelected", false);
      }
    },
  },
};
</script>

<style scoped>
.date-box {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 15.5vw;
}
.icon {
  cursor: pointer;
}
#form {
  background-color: #eaeced;
  padding: 5px;
  /* margin-left: 1px;
  margin-right: 1px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 50px; */
}

.search-box {
  width: 80%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
}
.search {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
input[type="search"] {
  margin-left: 5px;
  width: 22%;
}
.select-box {
  margin: 0 5px 0 5px;
  width: 20vw;
}
.search-icon {
  align-self: center;
  margin: 0 0 0 10px;
}
.flex {
  display: flex;
  margin-right: 10px;
  margin-left: 5px;
}
a {
  color: black;
  cursor: pointer;
}
.datepicker-trigger2 {
  display: flex;
}
</style>
